// const { NODE_ENV } = process.env;
// const ispro = NODE_ENV === 'pro';
// const diffEvn =
// {
//     dev_d: 'http://192.168.9.8:10081',
//     dev_t: 'http://192.168.9.141:10081',
//     dev_old: 'http://192.168.9.20:8080',
//     pro_d: 'http://192.168.9.8:10081',
//     pro_t: 'http://192.168.9.141:10081',
//     pro_old: 'http://192.168.9.20:8080',
//     pro: ''
// }
// 后端地址：打包时可由构建注入 __API_BASE__（如 https://10.112.204.121:8443），
// 未注入则回退 location.origin（同源部署 + nginx 反代）。
const url = __API_BASE__ || location.origin;

export const allUrl = {
    "ServiceAddress": url + "/bods.svc/",
    "ServletServiceAddress": url + "/",
    "TokenVerify": "/rest/auth/login",
    "mapUrl": url,
    "ServiceItoss": url + "/webloader",
    "platformType": "reactjs",
    "newsamUrl": "/newsam/",
    "wsUrl": "/websocket/wechat",
    "dashboardUrl": url + "/dashboard",
    "vlanUrl": url + "/vlan/index.html",
    "mobileUrl": url + "/mobilepc/ecc/index.html"
};

console.log(allUrl)

// let allUrl={
//     "ServiceAddress":diffEvn[NODE_ENV]+"/bods.svc/",
//     "ServletServiceAddress":"http://192.168.9.8:10081/",
//     "TokenVerify":"/rest/auth/login",
//     "mapUrl":"http://192.168.9.8:10081",
//     "ServiceItoss":"http://192.168.9.8:10081/webloader",
//     "platformType":"reactjs",
//     "newsamUrl": "/newsam/",
//     "wsUrl": "/websocket/wechat",
//     "dashboardUrl":"http://192.168.9.8:10081/dashboard",
//     "vlanUrl":"http://192.168.9.8:10081/vlan/index.html",
//     "mobileUrl":"http://192.168.9.8:10081//mobilepc/ecc/index.html"
// };